import * as React from 'react';
import { CheckboxGroup, TControlOptions } from '@cian/ui-kit';
import { Unit } from './components/Unit';
import * as styles from './styles.css';
import { FormInputsLayout } from '../FormInputsLayout';

export interface IPriceQuestionProps {
  value: string | number;
  selectedOptions?: string[];
  options?: TControlOptions | null;
  error: string;
  placeholder: string;
  unit?: string | null;

  onValueChange(value: string): void;

  onSelect?(selected: string[]): void;
}

export const PriceQuestion: React.FC<IPriceQuestionProps> = props => {
  const { placeholder, value, error, onValueChange, options, selectedOptions, onSelect, unit } = props;

  const handleValueChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, value: string) => onValueChange(value),
    [onValueChange],
  );
  const handleSelect = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, selected: string[]) => onSelect && onSelect(selected),
    [onSelect],
  );

  return (
    <div>
      <FormInputsLayout
        InputProps={{
          placeholder,
          value,
          errorMessage: error,
          invalid: !!error,
          onChange: handleValueChange,
          rightEnhancer: unit && <Unit text={unit} />,
        }}
      />
      {options && !!options.length && (
        <div className={styles['options']}>
          <CheckboxGroup disabled={!value} options={options} onChange={handleSelect} value={selectedOptions} />
        </div>
      )}
    </div>
  );
};

PriceQuestion.displayName = 'PriceQuestion';
